import { HttpResponse } from '@angular/common/http';
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FleetService } from 'src/app/services/fleet.service';
import { ToastService } from 'src/app/services/toastr.service';

@Component({
  selector: 'app-payment-pending',
  templateUrl: './payment-pending.component.html',
  styleUrls: ['./payment-pending.component.scss']
})
export class PaymentPendingComponent implements OnInit, OnDestroy {

  @ViewChild('mymodal8') modalconfirm!: ElementRef;
  display: any;
  orderId?: string;
  referenceId?: string;
  public timerInterval: any;

  constructor(
    private toastr: ToastService, 
    private router: Router,
    private fleetservice: FleetService, 
    private activateroute: ActivatedRoute,
    private modalService: NgbModal, 
    private modalRef: NgbActiveModal) { }
  
  ngOnInit(): void {
    debugger;
    this.activateroute.queryParams.subscribe(params => {
      const value = params['referenceid'];
      this.referenceId = value; // Output: refId
    });
    this.timer(5);
  }
  
  ngAfterViewInit(){
    this.statusCheck();
  }

  timer(minute: any) {
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;

    const prefix = minute < 10 ? '0' : '';
    
    this.timerInterval = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;
      
      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;
      
      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      
      if (seconds == 0) {
        console.log('finished');
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }
  
  statusCheck(){
    debugger;
    var j = false;
    this.orderId = sessionStorage.getItem('orderid')?.toString();
    if(this.orderId != null && this.referenceId != null){
      this.fleetservice._get_Status_Check(this.orderId,this.referenceId).subscribe((data:any)=>{
        debugger;
        console.log(data);
        if(data.isSuccess){
        //if(j){
          if (sessionStorage.getItem('pagename') == 'payment') {
            this.router.navigateByUrl('/customer/order-confirmation');
            this.toastr.showSuccess('Payment Success')
          } else {
            this.router.navigateByUrl('/customer/home');
            this.toastr.showSuccess('Payment Success')
          }
        }
        else{
          this.open(this.modalconfirm);
        }
      })
    }
    else{
      this.open(this.modalconfirm);
    }
  }

  open(content: any) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      // size:'lg'
    };

    this.modalRef = this.modalService.open(content, ngbModalOptions);

  }

  close() {
    this.modalRef.close();
    this.router.navigateByUrl('/customer/payment-gateway');
    this.toastr.showError('Payment Failure !!!, Try Again')
  }

  ngOnDestroy(): void {
    clearInterval(this.timerInterval);
  }
}

